var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.552,
    height: 8.412
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-check",
    d: "M10.137 1.414l-6 6-2.723-2.729",
    fill: "none",
    stroke: "#5f48e9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

export default SvgCheckPurple;